<div class="page" id="page_joinus">
    <div class="container">

        <div class="step" id="init">
            <img class="bgimg bgimg1" src="assets/tiny/duda-001-full.jpg" alt="" fetchpriority="high" decoding="async" />

            <div class="head">
                <h2 class="section-title">QUALIDADE DE VIDA</h2>
                <p>ATRAVÉS DAS ARTES MARCIAIS</p>
            </div>

            <div class="splitter"></div>

            <p>
                Um ambiente pensado nos <br/>
                mínimos detalhes, com <br/>
                estrutura completa, aulas em <br/>
                grupos reduzidos e um 
                método que une treinamento <br/>
                funcional e artes marciais para <br/>
                transformar a forma como você treina. <br/>
            </p>
            
            <a class="btn primary-line" (click)="navigate(true)">
                <span>ACESSAR O CLUBE</span>
                <fa-icon [icon]="faArrow" />
            </a>

            <div class="warning">
                <fa-icon [icon]="faLock" />

                <h2>VAGAS LIMITADAS</h2>
                <p>
                    Mantemos um número de membros <br/>
                    reduzido para preservar a experiência <br/>
                    NF Performance Club. <br/>
                </p>
            </div>
        </div>

        <div class="step" id="step1">
            @if (shouldLoadBackground(2)) {
                <img class="bgimg bgimg2" src="assets/tiny/duda-002-full.jpg" alt="" decoding="async" />
            }
            @if (shouldLoadBackground(4)) {
                <img class="bgimg bgimg4" src="assets/tiny/duda-004-full.jpeg" alt="" decoding="async" />
            }

            <div class="head">
                <h2 class="section-title">{{ str_title }}</h2>
                <br/>
                <p>{{ str_sub }}</p>
            </div>

            <div class="splitter"></div>

            <p>{{ str_label }}</p>

            <div class="frm">
                <form (submit)="frm_send()">
                    <input class="inputtxt frmname" type="text" 
                        [formControl]="frmname" placeholder="Nome" id="frmname" 
                        [class.input-invalid]="!s_frm_name()" />
                    <br/>
                    <input class="inputtxt frmmail" type="text" 
                        [formControl]="frmmail" value="" placeholder="Email" id="frmmail"
                        [class.input-invalid]="!s_frm_mail()" />
                    <br/>
                    <input class="inputtxt frmphone" type="text" 
                        [formControl]="frmphone" value="" placeholder="Telefone" id="frmphone"
                        [class.input-invalid]="!s_frm_phone()" 
                        mask="(00) 0.0000-0000" />
                    <br/>
                    
                </form>
            </div>
 

            <a class="btn second-line" (click)="navigate(false)">
                <fa-icon [icon]="faBack" />
            </a>
            <a class="btn primary-line" (click)="navigate(true)">
                <span>{{ str_btn }}</span>
                <fa-icon [icon]="faArrow" />
            </a>

            <a class="btn primary-txt" (click)="navigate(true)">
                <fa-icon [icon]="faBack" />
                <span>{{ str_btn }}</span>
                
            </a>

            <fa-icon [icon]="faCheck" class="stepicon" />
            
        </div>

        <div class="step" id="step4">

            <div class="head">
                <!-- <fa-icon [icon]="faCheck" /> -->
                <br/>
                <h2 class="section-title">{{ str_title }}</h2>
                <p>{{ str_sub }}</p>
            </div>

            <div class="splitter"></div>

            <p>{{ str_label }}</p>
<!--  
            <a class="btn primary-txt" (click)="navigate(true)">
                <span>{{ str_btn }}</span>
                <fa-icon [icon]="faCheck" />
            </a> -->

        </div>

        <div class="section-divider"></div>

        <!-- <section id="location" class="section" style="position: relative;">

            <div class="container">

                <h2 class="section-title">LOCALIZAÇÃO</h2>

                <ul class="info">
                <li>
                    <h4>Vila Olímpia • São Paulo </h4>
                    <div>
                    <fa-icon [icon]="faMapMarkerAlt" />
                    <p>
                        Rua Casa do ator, 1110 <br/>
                    </p>
                    </div>
                </li>
                <li>
                    <div class="actions">
                    <app-btn i_type="primary-line mid" i_destiny="whatsapp" i_label="BTN.WHATSAPP"></app-btn>
                    <app-btn i_type="second-line mid" i_destiny="maps" i_label="BTN.MAPS"></app-btn>
                </div>
                </li>
                </ul>

                <div class="map">
                <img src="assets/mock/map.png" alt="" />
                </div>

            </div>
        </section>

        <div class="section-divider"></div> -->


    </div>

    <section id="location" class="section" style="position: relative;">
        <div class="divbgmap">
            <img class="bgmap" src="assets/mock/map.png" alt="" /> 
        </div>
        <div class="container">

            <h2 class="section-title">LOCALIZAÇÃO</h2>

            <ul class="info">
            <li>
                <h4>Vila Olímpia • São Paulo </h4>
                <div>
                <fa-icon [icon]="faMapMarkerAlt" style="display: none" />
                <p>
                    Rua Casa do ator, 1110 <br/>
                </p>
                </div>
            </li>
            <li>
                <div class="actions">
                    <a class="btn primary-line" 
                        target="_blank"  
                        href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
                        style="opacity: 1">
                        <span>WHATSAPP</span>
                        <fa-icon [icon]="faWhatsapp" />
                    </a>
                        <!-- <app-btn i_type="primary-line mid" i_destiny="whatsapp" i_label="WHATSAPP"></app-btn>
                    
                    https://www.google.com/maps/dir//New+Fight+Performance+Club+%7C+Academia+de+artes+Marciais+%7C+Muay+Thai+-+Jiu-Jitsu+-+Boxe+-+Funcional+Fight+-+R.+Casa+do+Ator,+1100+-+Vila+Ol%C3%ADmpia,+S%C3%A3o+Paulo+-+SP,+04546-004/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x94ce5716c43024c3:0xce37a9f7e63c20af?sa=X&ved=1t:57443&ictx=111
                        -->

<!-- 
                    <a class="btn second-line" 
                        target="_blank"  
                        href="https://www.google.com/maps/dir//New+Fight+Performance+Club+%7C+Academia+de+artes+Marciais+%7C+Muay+Thai+-+Jiu-Jitsu+-+Boxe+-+Funcional+Fight+-+R.+Casa+do+Ator,+1100+-+Vila+Ol%C3%ADmpia,+S%C3%A3o+Paulo+-+SP,+04546-004/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x94ce5716c43024c3:0xce37a9f7e63c20af?sa=X&ved=1t:57443&ictx=111"
                        style="opacity: 1">
                        <span>VER NO MAPA</span>
                        <fa-icon [icon]="faMapMarkerAlt" />
                    </a> -->
                    <app-btn i_type="second-line mid" i_destiny="maps" i_label="BTN.MAPS"></app-btn>
                </div>
            </li>
            </ul>
<!-- 
            <div class="map">
            <img src="assets/mock/map.png" styl="" />
            </div> -->

        </div>
    </section>

    <div class="section-divider"></div>
</div>
